import EditPaymentLengthPageContainer from './container';

export default EditPaymentLengthPageContainer;
